export default "__VITE_PUBLIC_ASSET__86079746__"